import { createContext } from "react";

export type AdminFeatureFlagContextValues = {
  /**
   * Check whether an admin-user-scoped feature flag is enabled
   * for the current signed-in user.
   */
  isEnabled: (flagKey: string) => boolean;

  /** The raw resolved flags map (key -> enabled). */
  flags: Map<string, { enabled: boolean; group: string }>;

  loading: boolean;
};

export const AdminFeatureFlagContext =
  createContext<AdminFeatureFlagContextValues | null>(null);
